import styled from 'styled-components';

export const PaywallPaymentOnPageStyles = styled.section`
  margin: 48px auto 20px;
  padding: 0 16px;
  max-width: 540px;

  .subscriptions-title {
    margin-bottom: 24px;
  }
`;
